import React from 'react';
import { createPortal } from 'react-dom';

type PortalProps = {
  children: React.ReactNode;
};

const ModalWrapper = ({ children }: PortalProps) =>
  createPortal(children, document.body);

export default ModalWrapper;
